import React, { useState, useEffect } from 'react';
import './Hero.css';

const slides = [
  {
    id: 1,
    title: <>The Doctor At Home - Home <br /> Healthcare Services</>,
    subtitle: "Your Health. Your Home. Our Certified Doctors.",
    image: "https://images.unsplash.com/photo-1516549655169-df83a0774514?auto=format&fit=crop&w=2070",
  },
  {
    id: 2,
    title: <>The Doctor At Home - Home <br /> Healthcare Services</>,
    subtitle: "Your Health. Your Home. Our Certified Doctors.",
    image: "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
  },
  {
    id: 3,
    title: <>The Doctor At Home - Home <br /> Healthcare Services</>,
    subtitle: "Your Health. Your Home. Our Certified Doctors.",
    image: "https://plus.unsplash.com/premium_photo-1681842917626-e3456c461514?q=80&w=872&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  }
];

const Hero = () => {
  const [current, setCurrent] = useState(0);
  const [showForm, setShowForm] = useState(false);

  // Auto-slide logic
  useEffect(() => {
    const timer = setInterval(() => {
      if (!showForm) {
        setCurrent((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
      }
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length, showForm]);

  const handleClose = (e) => {
    e.preventDefault();
    setShowForm(false);
  };

  // --- Smooth Scroll Function ---
  const scrollToPortalSection = () => {
    // Ye function 'portal-access' ID wale section ko dhoondhega
    const portalSection = document.getElementById('portal-access');
    if (portalSection) {
      portalSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero-container">
      {/* --- SLIDING FORM --- */}
      <div className={`form-overlay ${showForm ? 'active' : ''}`}>
        <div className="glass-form">
          <button type="button" className="close-form" onClick={handleClose}>✕</button>
          <h3>Request Appointment</h3>
          <form className="grid-form" onSubmit={(e) => { e.preventDefault(); alert("Request Sent!"); setShowForm(false); }}>
            <div className="input-group">
              <input type="text" placeholder="Full Name" required />
              <input type="tel" placeholder="Contact No" required />
            </div>
            <div className="input-group">
              <input type="email" placeholder="Email Address" required />
              <select required className="form-dropdown" defaultValue="">
                <option value="" disabled>Select Education</option>
                <option value="mbbs">MBBS</option>
                <option value="bds">BDS</option>
                <option value="bhms">BHMS</option>
                <option value="nursing">B.Sc Nursing</option>
                <option value="other">Other</option>
              </select>
            </div>
            <div className="input-group">
              <input type="text" placeholder="Service Area" required />
              <input type="text" placeholder="Experience (Years)" required />
            </div>
            <textarea placeholder="Additional Comments..." rows="3"></textarea>
            <button type="submit" className="form-submit-btn">Submit Request</button>
          </form>
        </div>
      </div>

      {/* --- SLIDER --- */}
      {slides.map((slide, index) => (
        <div key={slide.id} className={`hero-slide ${index === current ? 'active' : ''}`}>
          <div className="hero-bg" style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.6)), url(${slide.image})` }}></div>
          
          <div className="hero-content">
            <h1 className="hero-title animate-up">{slide.title}</h1>
            <p className="hero-subtitle animate-up delay-1">{slide.subtitle}</p>
            
            <div className="hero-btns animate-up delay-2">
              <button className="btn-book" onClick={() => setShowForm(true)}>Book Doctor Home Visit</button>
              
              {/* Click karne par scroll karne wala button */}
              <button className="btn-portal" onClick={scrollToPortalSection}>Access Doctor Portal</button>
            </div>
          </div>
        </div>
      ))}

      {/* --- DOTS --- */}
      <div className="hero-dots">
        {slides.map((_, i) => (
          <span 
            key={i} 
            className={`dot ${i === current ? 'active' : ''}`} 
            onClick={() => setCurrent(i)}
          ></span>
        ))}
      </div>
    </section>
  );
};

export default Hero;